export class PdPlacesAutocomplete {
	public static readonly selector = '.js-places-autocomplete'

	private searchInput: HTMLInputElement
	private coordinatesInput: HTMLInputElement
	private submitButton: HTMLButtonElement

	private autocomplete: google.maps.places.Autocomplete

	public browserGeolocationOptions: PositionOptions = {
		enableHighAccuracy: true,
		timeout: 27000
	}

	public autocompleteOptions: google.maps.places.AutocompleteOptions = {
		types: ['geocode', 'establishment']
	}

	constructor(searchForm: HTMLFormElement) {
		const searchInput = searchForm.querySelector<HTMLInputElement>(`${PdPlacesAutocomplete.selector}__input`)
		const coordinatesInput = searchForm.querySelector<HTMLInputElement>(`${PdPlacesAutocomplete.selector}__coordinates`)
		const submitButton = searchForm.querySelector<HTMLButtonElement>(`${PdPlacesAutocomplete.selector}__btn`)

		if (!searchInput || !coordinatesInput || !submitButton) {
			throw new Error('PdPlacesAutocomplete: Missing element for query, coordinates or submit button!')
		}

		this.searchInput = searchInput
		this.coordinatesInput = coordinatesInput
		this.submitButton = submitButton

		this.autocompleteOptions.componentRestrictions = {
			country: searchForm.dataset.autocompleteCountry ? JSON.parse(searchForm.dataset.autocompleteCountry) : null
		}

		this.autocomplete = new google.maps.places.Autocomplete(this.searchInput, this.autocompleteOptions)

		this.autocomplete.addListener('place_changed', this.placeChanged.bind(this))
	}

	private placeChanged(): void {
		const place = this.autocomplete.getPlace()

		if (place.geometry && place.geometry.location) {
			this.submitCoordinates.call(this, place.geometry.location.lat(), place.geometry.location.lng())
		}
	}

	private submitCoordinates(lat: number, lng: number): void {
		const locationResult = {
			lat,
			lng
		}

		this.coordinatesInput.value = JSON.stringify(locationResult)
		this.submitButton.click()
	}
}
